import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const RecordNavigatorElementFields = {
  group: ELEMENT_GROUPS.NAVIGATION,
  label: 'Record Navigator',
  icon: 'DocumentTextIcon',
  description:
    'Displays a record navigator on a details screen to loop through lists of records',
  properties: [
    'layout',
    'font',
    'fontFamily',
    'alignment',
    'margin',
    'padding',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description:
        'Choose a data source that this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Show Text',
      name: 'showText',
      description:
        'If true, text is shown between the left and right navigation buttons',
      editor: 'switch',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Text',
      name: 'text',
      description:
        'The text is shown between the left and right navigation buttons',
      editor: 'textbox',
      default: 'My Navigator',
      displayWhen: [
        {
          field: 'showText',
          operator: '==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Text Padding',
      name: 'textPadding',
      editor: 'boundary',
      description: 'The padding of the text ',
      default: '0 0 0 0',
      displayWhen: [
        {
          field: 'showText',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Text Color',
      name: 'color',
      description: 'The color of the text between the buttons',
      editor: 'color',
      default: '#ffffff',
      displayWhen: [
        {
          field: 'showText',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Button Background Color',
      name: 'buttonBackgroundColor',
      description: 'The background color of the buttons',
      editor: 'color',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Button Disabled Background Color',
      name: 'buttonDisabledBackgroundColor',
      description: 'The background color of the buttons when disabled',
      editor: 'color',
      default: '#edf2f7',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Button Text Color',
      name: 'buttonTextColor',
      default: '#ffffff',
      description: 'The text color of the buttons',
      editor: 'color',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Button Disabled Text Color',
      name: 'buttonDisabledTextColor',
      default: '#4a5568',
      description: 'The text color of the buttons when they are disabled',
      editor: 'color',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Button Width',
      name: 'buttonWidth',
      default: 100,
      description: 'The width of the left and right buttons',
      editor: 'number',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Text Width',
      name: 'textWidth',
      default: 100,
      description: 'The width of the text between the buttons',
      editor: 'number',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Icon Size',
      name: 'iconsize',
      default: 8,
      description: 'The size of the left and right arrow icons',
      editor: 'number',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    }
  ]
};

export default RecordNavigatorElementFields;
